<template>
  <nav class="nav-bar">
    <!-- btn Crud -->
    <v-menu
      v-if="hasLoggedAccess"
      bottom
      origin="top left"
      transition="scale-transition"
      class="mytabs"
      offset-y
      open-on-click
      :close-on-content-click="true"
      :internal-activator="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="button-list"
          icon
          class="link neumorphism-out mr-5"
          v-bind="attrs"
          v-on="on"
          :aria-label="$t('nav.btnCrud')"
        >
          <v-icon> mdi-format-list-bulleted </v-icon>
        </v-btn>
      </template>

      <v-list nav>
        <!--user profil-->
        <v-list-item>
          <v-list-item-avatar>
            <img
              :src="user.imagePath"
              :alt="user.firstName + ' ' + user.lastName"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{
              user.firstName + " " + user.lastName
            }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.company }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!--user profil-->

        <div class="prefBtn">
          <!-- <theme-btn /> -->

          <v-menu offset-y close-on-click>
            <v-list>
              <v-list-item
                v-for="(loc, index) in locales"
                :key="index"
                @click="changeLocale(loc.code)"
              >
                <v-list-item-title>
                  {{ loc.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-divider></v-divider>

        <v-list-item-group v-model="selectedItem" color="red">
          <!--Fields access by all users type-->
          <div>
            <v-list-item @click="goTo('/' + $i18n.locale + '/profile')">
              <v-list-item-action>
                <v-icon> mdi-card-account-details-outline </v-icon>
              </v-list-item-action>

              <v-list-item-title>
                {{ $t("nav.profile") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="exportCal">
              <v-list-item-action>
                <v-icon> mdi-calendar </v-icon>
              </v-list-item-action>
              <v-list-item-title>
                {{ $t("nav.export") }}
              </v-list-item-title>
            </v-list-item>
          </div>
          <!--Fields access by all users type-->

          <v-divider></v-divider>

          <div v-if="hasRestrictedAccess">
            <!--Start field in crud button-->
            <v-list-item
              v-for="item in crudsStart"
              :key="item.link"
              @click="goTo('/' + $i18n.locale + item.link)"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ item.zone }}</v-list-item-content>
            </v-list-item>
            <!--Start field in crud button-->

            <!--button for Resources-->
            <v-menu offset-y :attach="true">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-icon>
                    <v-icon>{{ path }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{ $t("nav.resources") }}
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list>
                <v-list-item
                  v-for="item in crudsResources"
                  :key="item.link"
                  v-on:click="goTo('/' + $i18n.locale + item.link)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>{{ item.zone }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <!--button for Resources-->

            <!-- button for history-->
            <v-menu :attach="true" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-icon>
                    <v-icon>mdi-history</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{ $t("nav.history") }}
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!--Start History Button-->

              <v-list>
                <v-list-item
                  v-for="item in crudsHistory"
                  :key="item.link"
                  v-on:click="goTo('/' + $i18n.locale + item.link)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>{{ item.zone }}</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <!--End button for history-->

            <!-- End field in crud button-->
            <v-list-item
              v-for="item in crudsEnd"
              :key="item.link"
              @click="goTo('/' + $i18n.locale + item.link)"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ item.zone }}</v-list-item-content>
            </v-list-item>
            <!--End field in crud button-->
          </div>

          <!-- Start Menu Record -->
          <div v-if="hasRestrictedAccess" class="mytabs">
            <v-menu
              bottom
              origin="top left"
              transition="scale-transition"
              class="mytabs"
              offset-y
            >
            </v-menu>
          </div>
        </v-list-item-group>

        <!-- End Menu Record -->

        <v-divider></v-divider>

        <!--logout field-->
        <v-list-item @click="logOut()">
          <v-list-item-action>
            <v-icon> mdi-logout </v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("nav.logout") }}</v-list-item-title>
        </v-list-item>
        <!--logout field-->
      </v-list>
    </v-menu>
    <!-- logo next to btn Crud -->
    <h1 class="logo">
      {{ $t("nav.title") }}
    </h1>
    <v-spacer></v-spacer>

    <!--header buttons-->
    <div class="tabs-group">
      <div v-if="hasLoggedAccess" class="mytabs">
        <div>
          <router-link
            class="link"
            active-class="neumorphism-in"
            :to="'/' + $i18n.locale + '/calendar'"
            ><v-icon left v-if="$vuetify.breakpoint.mdAndUp">
              {{ "mdi-calendar" }}
            </v-icon>
            <span>{{ $t("nav.calendar") }}</span>
          </router-link>

          <router-link
            class="link"
            active-class="neumorphism-in"
            :to="'/' + $i18n.locale + '/centers'"
            ><v-icon left v-if="$vuetify.breakpoint.mdAndUp">
              {{ "mdi-widgets-outline" }}
            </v-icon>
            <span>{{ $t("nav.rooms") }}</span>
          </router-link>

          <router-link
            class="link"
            active-class="neumorphism-in"
            :to="`/${$i18n.locale}/mybookings`"
          >
            <v-icon left v-if="$vuetify.breakpoint.mdAndUp">
              {{ "mdi-book-account-outline" }}
            </v-icon>
            <span>{{ $t("nav.myBookings") }}</span>
          </router-link>

          <router-link
            v-if="hasRestrictedAccess"
            class="link"
            active-class="neumorphism-in"
            :to="'/' + $i18n.locale + '/eventsparent'"
            ><v-icon left v-if="$vuetify.breakpoint.mdAndUp">
              {{ "mdi-link-variant" }}
            </v-icon>
            <span>{{ $t("nav.parentEvents") }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <!--header buttons-->
    <v-spacer></v-spacer>

    <!--language and theme buttons-->
    <div>
      <theme-btn />

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            :title="$t('nav.tooltipLanguage')"
            class="neumorphism-out"
          >
            <v-icon>mdi-translate </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="item in locales"
            :key="item.code"
            v-on:click="changeLocale(item.code)"
          >
            <v-list-item-avatar>
              <v-avatar size="25">
                <v-img :src="getIconPath(item.img)"></v-img>
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <div v-html="item.name"></div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <!--language and theme buttons-->
  </nav>
</template>

<script>
import router from "@/router/index";
import AuthService from "@/services/planning/AuthService";
import { exportCalendar } from "@/services/planning/InterventionServices";
import { mapActions } from "vuex";
import ThemeBtn from "@/components/components-base/nav/subcomponent/ThemeBtn.vue";
import { mdiToolbox } from "@mdi/js";

export default {
  components: {
    ThemeBtn,
  },
  name: "NavBar",
  data() {
    return {
      path: mdiToolbox,
      selectedItem: null,
      locales: [
        {
          code: "en",
          base: "/en",
          flag: "us",
          name: "English",
          translations: "/translations/en.json",
          img: "Anglais.png",
        },
        {
          code: "fr",
          base: "/fr",
          flag: "fr",
          name: "Français",
          translations: "/translations/fr.json",
          img: "Francais.png",
        },
      ],
      dark: false,
      user: {},
      menu: true,
      group: null,

      crudsStart: [
        {
          zone: this.$t("nav.trainings"),
          icon: "mdi-school",
          link: "/formations",
        },
        {
          zone: this.$t("nav.locations"),
          icon: "mdi-map-marker",
          link: "/lieux",
        },
        {
          zone: this.$t("nav.centers"),
          icon: "mdi-home",
          link: "/admin/centers",
        },
      ],
      crudsResources: [
        {
          zone: this.$t("nav.rooms"),
          icon: "mdi-widgets",
          link: "/admin/rooms",
        },
        {
          zone: this.$t("nav.equipments"),
          icon: "mdi-monitor",
          link: "/admin/equipments",
        },
        {
          zone: this.$t("nav.desks"),
          icon: "mdi-desk",
          link: "/admin/desks",
        },
        {
          zone: this.$t("nav.categories"),
          icon: "mdi-view-dashboard-outline",
          link: "/admin/categories",
        },
      ],
      crudsHistory: [
        {
          zone: this.$t("nav.mementoRecord"),
          icon: "mdi-history",
          link: "/memento",
        },
        {
          zone: this.$t("nav.mementoReservation"),
          icon: "mdi-history",
          link: "/admin/booking-history",
        },
        {
          zone: this.$t("nav.sync"),
          icon: "mdi-cloud-download",
          link: "/imports",
        },
      ],
      crudsEnd: [
        {
          zone: this.$t("nav.users"),
          icon: "mdi-account-group",
          link: "/employes",
        },
      ],
    };
  },

  computed: {
    hasLoggedAccess() {
      return this.user.type !== "visitor" && this.menu;
    },
    hasRestrictedAccess() {
      return (
        this.user.type !== "visitor" &&
        AuthService &&
        AuthService.userHasSomeRoles(["ADMINISTRATIF", "COMMERCIAL"])
      );
    },
  },
  watch: {
    // trouver un meilleur watcher
    $route(to, from) {
      if ($cookies.isKey("config")) {
        let cookiesConfig = $cookies.get("config");

        if (cookiesConfig.theme === "dark") {
          this.dark = true;
        }
        if (cookiesConfig.theme === "light") {
          this.dark = false;
        }
      }
      this.getUserStatus();
    },
  },
  created() {
    window.addEventListener("resize", this.getUserStatus);
    this.user.type = "visitor";
  },
  methods: {
    getUserStatus() {
      if ($cookies.isKey("auth")) {
        this.user = AuthService.getUser();
        this.menu = true;
      } else {
        this.user.type = "visitor";
      }
    },
    getIconPath(fileName) {
      return require("@/assets/images/icons/" + fileName);
    },

    ...mapActions("notificationModule", ["showNotification"]),
    changeLocale(loc) {
      this.$i18n.locale = loc;
      router
        .push({
          params: { lang: loc },
        })
        .catch((err) => {});
      router.go();
    },
    goTo(route) {
      router.push(route).catch(() => {});
    },
    logOut() {
      this.menu = false;
      AuthService.logout();
      router.push("/" + this.$i18n.locale);
    },
    recordClick(record) {
      this.$router.push("/" + this.$i18n.locale + record.link);
    },
    async exportCal() {
      const user = AuthService.getAuth().user;
      const filename = `${user.firstName}${user.lastName}.ics`;

      await exportCalendar(user.id, filename).then((e) => {
        if (e === 404) {
          this.showNotification({
            messageAlert: this.$t("nav.exportError"),
            typeAlert: "info",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.nav-bar {
  border-radius: 10px;
  display: flex;
  align-items: center;
  margin: 10px auto;
  padding: 10px 20px;

  .link {
    color: var(--text-color);
    padding: 10px 15px;
    border-radius: 20px;
  }

  .active-link {
    color: rgb(255, 64, 64);
    transition: color 0.5s;
  }

  .logo {
    transition: color 0.5s;
    color: var(--text-color);
  }

  .btn-theme {
    margin: 0 0 0 10px;
  }

  .tabs-group {
    .mytabs {
      display: flex;
      align-items: center;
    }
  }
}
.prefBtn {
  display: flex;
  justify-content: space-around;
}
</style>
